// extracted by mini-css-extract-plugin
module.exports = {"overlay":"spinner-overlay_overlay__eTMXd","hidden":"spinner-overlay_hidden__ER6tn"};